import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { BehaviorSubject, filter } from 'rxjs';

import { ENVIRONMENT } from '../environments/environment.token';

@Injectable({ providedIn: 'root' })
export class PageService {
  public appName!: string;
  currentPath$ = new BehaviorSubject<string>('');

  private router = inject(Router);
  private environment = inject(ENVIRONMENT);

  constructor() {
    this.updateAppName();

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.currentPath$.next(this.router.url);
    });

    if (this.router.url) {
      this.currentPath$.next(this.router.url);
    }
  }

  private updateAppName(): void {
    this.appName = this.environment.appName;
  }
}
